import React, { useState, useEffect } from 'react';

const GreenbearWebsite = () => {
  const [screenType, setScreenType] = useState('wide');
  const [viewportHeight, setViewportHeight] = useState('100vh');

  useEffect(() => {
    let lastWidth = window.innerWidth;
    
    const checkScreenType = () => {
      const width = window.innerWidth;
      if (width <= 767) {
        setScreenType('mobile');
      } else {
        setScreenType('wide');
      }
    };

    // Calculate actual viewport height for Safari
    const updateViewportHeight = () => {
      const vh = window.innerHeight;
      setViewportHeight(`${vh}px`);
    };

    // Only update viewport on significant resize (not just address bar)
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      
      // Check if width changed (real resize or orientation change)
      if (currentWidth !== lastWidth) {
        lastWidth = currentWidth;
        checkScreenType();
        updateViewportHeight();
      }
    };

    // Handle orientation change specifically
    const handleOrientationChange = () => {
      setTimeout(() => {
        updateViewportHeight();
        checkScreenType();
      }, 100); // Small delay to ensure Safari has updated
    };

    checkScreenType();
    updateViewportHeight();
    
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  // Select images based on screen type
  let heroImage, infoImage;
  if (screenType === 'mobile') {
    heroImage = '/greenbear-hero-mobile.webp';
    infoImage = '/greenbear-info-mobile.webp';
  } else {
    heroImage = '/greenbear-hero-wide.webp';
    infoImage = '/greenbear-info-wide.webp';
  }

  // Check if it's iPad size for special image handling
  const isTablet = screenType === 'wide' && window.innerWidth < 1400;

  if (screenType === 'mobile') {
    // Mobile: Simple stacked images
    return (
      <div style={{ backgroundColor: '#b6d8b6' }}>
        <img 
          src={heroImage}
          alt="Greenbear Garden Care - The only time you'll be glad to have a bear in your garden" 
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
        <img 
          src={infoImage}
          alt="Greenbear Garden Care - Business information" 
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </div>
    );
  }

  // Desktop/Tablet/Wide: Full viewport sections with Safari fixes
  return (
    <div style={{ overflowX: 'hidden' }}>
      {/* Hero Section */}
      <div style={{ 
        height: viewportHeight,
        minHeight: '-webkit-fill-available', // Safari fallback
        backgroundColor: '#b6d8b6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        transform: 'translateZ(0)', // Force hardware acceleration for Safari
        WebkitTransform: 'translateZ(0)',
        willChange: 'transform', // Optimize for transformations
        backfaceVisibility: 'hidden', // Prevent flickering
        WebkitBackfaceVisibility: 'hidden',
        perspective: 1000 // Create stacking context for better performance
      }}>
        <img 
          src={heroImage}
          alt="Greenbear Garden Care - The only time you'll be glad to have a bear in your garden" 
          style={{ 
            width: isTablet ? 'auto' : '100%',
            height: '100%',
            maxWidth: isTablet ? 'none' : '100%',
            minWidth: isTablet ? '100%' : 'auto',
            alignSelf: 'center', // Explicit flex alignment for Safari
            objectFit: 'cover',
            objectPosition: 'center',
            position: 'relative',
            display: 'block' // Ensures proper rendering in Safari
          }}
        />
      </div>

      {/* Info Section */}
      <div style={{ 
        height: viewportHeight,
        minHeight: '-webkit-fill-available',
        backgroundColor: '#101c0c',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        transform: 'translateZ(0)', // Force hardware acceleration
        WebkitTransform: 'translateZ(0)',
        willChange: 'transform', // Optimize for transformations
        backfaceVisibility: 'hidden', // Prevent flickering
        WebkitBackfaceVisibility: 'hidden'
      }}>
        <img 
          src={infoImage}
          alt="Greenbear Garden Care - Business information" 
          style={{ 
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
      </div>
    </div>
  );
};

export default GreenbearWebsite;